module.exports = __webpack_public_path__ + "img/umrahsaf.5b5efe2b.jpg";